var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteeringWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2047_901)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1546 3.88477C29.3596 3.88477 36.8213 11.533 36.8213 20.9681C36.8213 30.4032 29.3596 38.0514 20.1546 38.0514C10.9496 38.0514 3.48798 30.4032 3.48798 20.9681C3.48798 11.533 10.9496 3.88477 20.1546 3.88477ZM14.0096 25.719C12.2696 24.2925 9.90964 23.7407 7.16298 24.0585C7.74595 26.6254 9.03971 28.9651 10.8888 30.7964C12.7378 32.6277 15.0635 33.8728 17.5863 34.3819C17.2646 29.8976 15.8263 27.2052 14.0096 25.719ZM26.2996 25.719C24.483 27.2086 23.0446 29.8976 22.723 34.3802C25.2453 33.8709 27.5704 32.626 29.4191 30.795C31.2679 28.964 32.5615 26.6248 33.1446 24.0585C30.3996 23.7407 28.0396 24.2925 26.2996 25.719ZM20.1546 17.5514C18.5713 17.5514 17.268 18.1835 16.3113 18.8805L15.4813 19.4733C14.608 20.0798 13.6046 20.7033 12.4796 21.1133C13.7933 21.5165 15.0193 22.1741 16.0913 23.0506C17.9646 24.5881 19.3463 26.7867 20.1546 29.643C20.963 26.7867 22.3446 24.5863 24.218 23.0506C25.2901 22.1747 26.5161 21.5176 27.8296 21.115C26.7046 20.7033 25.7013 20.0798 24.828 19.4733L23.998 18.8805C23.0413 18.1835 21.738 17.5514 20.1546 17.5514ZM20.1546 7.30143C17.0483 7.30186 14.0394 8.4136 11.6473 10.4448C9.25513 12.4761 7.62965 15.2994 7.05131 18.4278L6.97964 18.8515L10.663 18.0964C11.633 17.8982 12.5546 17.3738 13.5846 16.6614L14.3796 16.0942C15.708 15.1273 17.6763 14.1348 20.1546 14.1348C22.468 14.1348 24.3363 14.9992 25.6546 15.9012L26.7246 16.6614C27.6246 17.2849 28.4446 17.7633 29.2846 18.0076L29.6463 18.0964L33.3296 18.8515C32.8367 15.6328 31.2384 12.7005 28.8228 10.5829C26.4073 8.46522 23.3332 7.30151 20.1546 7.30143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2047_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white",
    transform: "translate(0.154663 0.46875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteeringWheel);
export default __webpack_public_path__ + "static/media/steering_wheel.53dc99713200df00af1143c38b28ee47.svg";
export { ForwardRef as ReactComponent };